module.exports = __webpack_public_path__ + "img/LogoHigh.302b8ee1.png";